import { Category } from "../../category/category";

export class responseUpdateExpensesProduct {
    category:Category;
    stats:any; 
    constructor (data){
        this.category = new Category(data.category);
        this.stats = data.stats; 
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-update-expenses-product.ts